import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

interface Props {
    children: React.ReactNode;
    onApprove: (event: React.MouseEvent<HTMLButtonElement>) => void;
    buttonClassName?: string;
    buttonStyle?: React.CSSProperties;
    withFinishNotifications?: boolean;
    customModalTitle?: React.ReactNode;
    customModalBody?: React.ReactNode;
    modalSize?: 'large' | 'small';
}

const ButtonWithModalConfirmation: React.FC<Props> = ({
    children,
    onApprove,
    customModalTitle,
    customModalBody,
    buttonClassName,
    buttonStyle,
    modalSize = 'small',
}) => {
    const [showModal, setShowModal] = useState(false);

    const onApproveHandler = (event) => {
        onApprove(event);
        setShowModal(false);
    };

    return (
        <div>
            <button
                className={buttonClassName ? buttonClassName : 'wfp-btn--primary'}
                onClick={(event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    setShowModal(true);
                }}
                style={buttonStyle ? buttonStyle : {}}
                type="button"
            >
                {children}
            </button>
            {showModal && (
                <ModalConfirmation
                    body={customModalBody}
                    modalSize={modalSize}
                    onApprove={onApproveHandler}
                    onClose={() => setShowModal(false)}
                    title={customModalTitle}
                />
            )}
        </div>
    );
};

ButtonWithModalConfirmation.displayName = 'ButtonWithModalConfirmation';

interface ModalConfirmationProps {
    title?: React.ReactNode;
    body?: React.ReactNode;
    customModalTitle?: React.ReactNode;
    customModalBody?: React.ReactNode;
    onClose: () => void;
    onApprove: (event: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
    modalSize: 'large' | 'small';
}

const ModalConfirmation: React.FC<ModalConfirmationProps> = ({ modalSize, title, body, onClose, onApprove }) => {
    const defaultModalTitle = 'Confirmation is required';
    const defaultModalMessage = 'Do you confirm ?';

    const modalDialogClassName = `modal-${modalSize}`;

    return (
        <Modal backdrop="static" centered dialogClassName={modalDialogClassName} keyboard={false} onHide={onClose} show>
            <Modal.Header>
                <Modal.Title>{title || defaultModalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={'text-left'}>{body || defaultModalMessage}</Modal.Body>
            <Modal.Footer>
                <button className="wfp-btn negative-color" onClick={onClose} style={{ marginRight: 10 }} type="button">
                    Close
                </button>
                <button className="wfp-btn--primary" onClick={onApprove} style={{ marginRight: 10 }} type="button">
                    Approve
                </button>
            </Modal.Footer>
        </Modal>
    );
};

ModalConfirmation.displayName = 'ModalConfirmation';

export { ButtonWithModalConfirmation };
